import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Queen MJ Maison Beaute";
export const SITE_URL = "https://www.queenmjmaison.store";
const DEFAULT_DESC = "Queen MJ Maison Beaute — a premium fragrance destination for elegant perfumes, air fresheners and luxury candles. Authentic parfums, complimentary shipping over $150, easy returns.";
const DEFAULT_IMG = "https://customer-assets-lxgj4vgw.emergentagent.net/job_fragrance-luxury-29/artifacts/2fqee0j4_Shaher%204.png";

export default function SEO({ title, description, image, path = "", type = "website", jsonLd }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Luxury Perfumes & Home Fragrance`;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMG;
  const url = SITE_URL + path;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
